const SET_REPEATED_FROM = 'directOrder/SET_REPEATED_FROM';

export default {
  SET_REPEATED_FROM,
};
